import { render, staticRenderFns } from "./shop.card2.vue?vue&type=template&id=ea17f406&"
import script from "./shop.card2.vue?vue&type=script&lang=js&"
export * from "./shop.card2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports